import React from 'react';
import './style.css';

// Helper function to map card string to image path
const getCardImage = (cardString) => {
  if (!cardString) return null;
  // Adjust path to match where images are stored in Admin
  return `/assets/img/cards/${cardString}.png`;
};

// Helper function to parse card string and split into Player A and Player B cards
const parseCards = (cardString) => {
  if (!cardString) return { playerA: [], playerB: [] };

  const cards = cardString.split(',');
  const playerACards = cards.slice(0, 3).map(card => getCardImage(card.trim()));
  const playerBCards = cards.slice(3, 6).map(card => getCardImage(card.trim()));

  return { playerA: playerACards, playerB: playerBCards };
};

// Helper function to parse rdesc
const parseRdesc = (rdesc) => {
  if (!rdesc) return {};

  const parts = rdesc.split('#');
  const winner = parts[0] || "";

  // Part 1: 3 Baccarat (may contain ~ with score)
  const baccarat3Full = parts[1] || "";
  let baccarat3 = "";
  let baccaratScore = "";
  if (baccarat3Full.includes('~')) {
    const baccaratParts = baccarat3Full.split('~');
    baccarat3 = baccaratParts[0] || "";
    baccaratScore = baccaratParts[1] || "";
  } else {
    baccarat3 = baccarat3Full;
  }

  // Part 2: Total
  const total = parts[2] || "";

  // Part 3: Pair Plus - skip (always empty, no data from backend)
  // Part 4: Red Black (or Part 3 if Pair Plus is empty)
  const redBlack = parts[4] || parts[3] || "";

  return { winner, baccarat3, baccaratScore, total, redBlack };
};

const Teen20c = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  // Parse cards from detailResult
  const cards = detailResult?.card ? parseCards(detailResult.card) : { playerA: [], playerB: [] };
  const rdescData = detailResult?.rdesc ? parseRdesc(detailResult.rdesc) : {};
  const winner = detailResult?.winnat || "";
  
  // Determine winner from API data
  const winValue = detailResult?.win;
  const isPlayerAWinner = winValue === "1" || winner === "Player A";
  const isPlayerBWinner = winValue === "2" || winner === "Player B";

  return (
    <div>
      {/* Heading */}
      <div className="text-center">
        <h6>20-20C Teenpatti Result</h6>
      </div>

      {/* Round ID and Player Cards Section */}
      <div className="d-block text-center">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <span className="float-right round-id">
                <b>Round ID:</b> {roundId}
              </span>
            </div>
          </div>
          <div className="row bottom-border-casino m-t-10">
            <div className="col-md-12">
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '12px' }} className="player-image-container">
                <div className="text-center player-number" style={{ flex: '1' }}>
                  <h4>Player A</h4>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '8px' }}>
                    {cards.playerA?.map((card, index) => (
                      card && (
                        <img
                          key={index}
                          src={card}
                          alt={`Player A Card ${index + 1}`}
                          onError={(e) => {
                            const cardName = card.split('/').pop();
                            const fallbackPath = `/assets/img/card-results/${cardName}`;
                            if (e.target.src !== fallbackPath) {
                              e.target.src = fallbackPath;
                            } else {
                              e.target.style.display = 'none';
                            }
                          }}
                        />
                      )
                    ))}
                  </div>
                  <div className="text-center">
                    {isPlayerAWinner ? (
                      <label style={{ width: '100%' }} className="winner-label bg-success m-t-20">
                        <i className="fas fa-trophy m-r-5"></i>Winner
                      </label>
                    ) : (
                      <label className="m-t-20">&nbsp;</label>
                    )}
                  </div>
                </div>

                <div className="text-center player-number" style={{ flex: '1' }}>
                  <h4>Player B</h4>
                  <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '8px' }}>
                    {cards.playerB?.map((card, index) => (
                      card && (
                        <img
                          key={index}
                          src={card}
                          alt={`Player B Card ${index + 1}`}
                          onError={(e) => {
                            const cardName = card.split('/').pop();
                            const fallbackPath = `/assets/img/card-results/${cardName}`;
                            if (e.target.src !== fallbackPath) {
                              e.target.src = fallbackPath;
                            } else {
                              e.target.style.display = 'none';
                            }
                          }}
                        />
                      )
                    ))}
                  </div>
                  <div className="text-center">
                    {isPlayerBWinner ? (
                      <label style={{ width: '100%' }} className="winner-label bg-success m-t-20">
                        <i className="fas fa-trophy m-r-5"></i>Winner
                      </label>
                    ) : (
                      <label className="m-t-20">&nbsp;</label>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Result Details */}
      {/* {rdescData && (rdescData.baccarat3 || rdescData.total || rdescData.redBlack) && (
        <div className="mt-4 text-left">
          {rdescData.baccarat3 && (
            <p className="m-b-0">
              <b>3 Baccarat:</b> {rdescData.baccarat3} {rdescData.baccaratScore && `(${rdescData.baccaratScore})`}
            </p>
          )}
          {rdescData.total && (
            <p className="m-b-0">
              <b>Total:</b> {rdescData.total}
            </p>
          )}
          {rdescData.redBlack && (
            <p className="m-b-0">
              <b>Red/Black:</b> {rdescData.redBlack}
            </p>
          )}
        </div>
      )} */}
    </div>
  );
};

export default Teen20c;
